import styled from 'styled-components';
import * as awsui from '@amzn/awsui-design-tokens';

const ContainerHeader = styled.div`
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    flex-wrap: wrap;
`;

const DashboardWrapper = styled.div`
    .alert-banner {
        position: fixed !important; //override default styling
        z-index: 10; //overlay existing content
        width: 100%;
        top: 0;
    }
`;

const DashboardBody = styled.div`
    height: 100vh;
    background-color: ${awsui.colorBackgroundContainerContent};
    padding: 1% 2%;
`;

const DashboardTable = styled.div`
    margin-top: 20px;
`;

const HeaderButtons = styled.div`
    display: flex;
    flex-direction: row;
    align-items: center;
    gap: 8px;
    flex-wrap: wrap;
`;

const HeaderWrapper = styled.div`
    display: flex;
    flex-direction: row;
    align-items: center;
    gap: 8px;  
    flex-wrap: wrap;
`;

const HeaderText = styled.div`
    max-width: 500px;
`;

const LoadingWrapper = styled.div`
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
`;

const SearchWrapper = styled.div`
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    flex: 1 1 auto;
    align-items: center;

    .filter-container {
        width: 100%;
    }
`;

const SearchSubmitWrapper = styled.div`
    display: flex;
    flex-direction: row;
    justify-content: flex-end;
    align-items: center;
    margin-top: 10px;
`;

const FilterWrapper = styled.div`
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    flex: 1 1 auto;
    align-items: center;

    .filter-container {
        width: 100%;
    }
`;

const FilterSubmitWrapper = styled.div`
    display: flex;
    flex-direction: row;
    justify-content: flex-end;
    align-items: center;
    margin-top: 32px;
    z-index: 2;
`;

const ReviewDetailsContainer = styled.div`
    margin-bottom: 20px;
`;

const ReviewLabel = styled.p`
    font-size: 14px;
    margin-bottom: 5px;
    margin-right: 10px;
`;

const ReviewValue = styled.p`
    font-size: 14px;
    font-weight: bold;
    margin-bottom: 5px;
`;

const ReviewRow = styled.div`
    display: flex;
    margin-bottom: 20px;
`;

const ReviewColumn = styled.div`
    flex: 50%;
    padding-left: 5px;
    padding-right: 5px;
`;

const SectionSubHeader = styled.p`
    font-size: 18px;
    text-align: left;
`;

const SectionDetails = styled.p`
`;

const SectionLabel = styled.span`
    font-size: 14px;
    margin-bottom: 5px;
    margin-right: 10px;
`;

const SectionValue = styled.span`
    font-size: 14px;
    font-weight: bold;
    margin-bottom: 5px;
    margin-right: 10px;
`;

const SectionNotes = styled.div`
    margin-top: 10px;
`;

const ErrorMessaging = styled.div`
    color: red;
    font-family: equiplight;
    font-size: 14px;
    padding: 1%;
    text-align: left;
    white-space: pre-line;
`;

const NotesPreview = styled.div`
    border-radius: 5px;
    border: 1px solid #ced4da;
    padding: 2%;
    max-height: 250px;
    overflow-y: scroll;
    margin-bottom: 20px;
`;

const TableHeader = styled.div`
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    justify-content: space-between;
    margin-bottom: -25px;

    h2 {
        padding: 15px 15px 0px 0px;
    };

    @media (max-width: 1000px) {
            margin-bottom: 0px;
    }
`;

export default {
    ContainerHeader,
    DashboardWrapper,
    DashboardBody,
    DashboardTable,
    ErrorMessaging,
    FilterWrapper,
    FilterSubmitWrapper,
    HeaderButtons,
    HeaderWrapper,
    HeaderText,
    LoadingWrapper,
    NotesPreview,
    ReviewDetailsContainer,
    ReviewLabel,
    ReviewValue,
    ReviewRow,
    ReviewColumn,
    SearchWrapper,
    SearchSubmitWrapper,
    SectionSubHeader,
    SectionDetails,
    SectionLabel,
    SectionValue,
    SectionNotes,
    TableHeader,
};